<!-- 修改密码 -->
<template>
  <div class="u-pw">
    <!-- <h3 class="title">修改个人密码</h3> -->
    <el-descriptions :column="2" border title="修改个人密码">
      <el-descriptions-item>
        <template slot="label">
          <i class="iconfont iconGroup-"></i>
          用户名
        </template>
        {{$tools.sessionGetStore('user_name')}}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="iconfont iconjiumima"></i>
          旧密码
        </template>
        <el-input :class="test(formData.oldPassword)" v-model.trim="formData.oldPassword" type="password" placeholder="请输入旧密码"></el-input>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="iconfont iconxinmima"></i>
          新密码
        </template>
        <el-input :class="test(formData.password)" v-model.trim="formData.password" type="password" placeholder="请输入新密码"></el-input>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="iconfont iconquerenmima"></i>
          确认密码
        </template>
        <el-input :class="test(formData.confirmPassword)" v-model.trim="formData.confirmPassword" type="password" placeholder="请再次输入新密码"></el-input>
      </el-descriptions-item>
    </el-descriptions>
    <div class="btn mt-20">
      <el-button type="primary" @click="subHandle">立即提交</el-button>
      <el-button @click="reset">重置</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formData: {
        oldPassword: '',
        password: '',
        confirmPassword: ''
      }
    }
  },
  computed: {
    test() {
      return function(ct) {
        return ct ? '' : 'not-filled-in'
      }
    }
  },
  methods: {
    subHandle() {
      if(Object.values(this.formData).includes('')) {
        this.$message.warning('有内容未填')
        return
      }
      if(Object.values(this.formData).includes('')) {
        this.$message.warning('有内容未填')
        return
      }
      if(this.formData.password != this.formData.confirmPassword) {
        this.$message.warning('两次密码输入不一致')
        return
      }
      let paramObj = {
        oldPassword: this.$md5(this.formData.oldPassword),
        password: this.$md5(this.formData.password),
        id: this.$tools.sessionGetStore('user_id'),
      }
      delete paramObj.confirmPassword
      this.$api.upPSHandle(paramObj)
      .then(res => {
        console.log(res)
        if(res.data.code == 0) {
          this.$confirm('修改密码成功，请重新登录','',{
            confirmButtonText: '重新登录',
            showClose: false,
            showCancelButton: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            closeOnHashChange: false,
            center: true,
            type: 'success'
          })
          .then(()=> {
            this.$tools.sessionClearStore()
            this.$router.push('/login')
          })
          this.reset()
        } else {
          this.$message.error(res.data.msg)
        }
      })
      .catch(error => {
        console.log(error)
        this.$message.error('操作失败，请联系技术部')
      })
    },
    reset() {
      Object.keys(this.formData).forEach(key => this.formData[key] = '')
    },
  }
}
</script>

<style lang="scss" scoped>
.u-pw {
  padding: 20px;
  .title {
    font-size: 20px;
  }
  ::v-deep.el-descriptions-item__label.is-bordered-label {
    color: #000;
    width: 200px;
    text-align:center;
    font-size: 14px;
  }
  .not-filled-in {
    ::v-deep.el-input__inner {
      border-color: red; 
    }
  }
}
</style>